'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Verifies that a user role or
 * entity role is above a target role
 */
var roles = [null, 'guest', 'contributor', 'editor', 'admin', 'super_admin'];
var wrapArray = function wrapArray(object) {
  if (Array.isArray(object)) {
    return object;
  }

  return [object];
};

exports.default = function (target, source) {
  var entities = wrapArray(source);
  var len = entities.length;

  for (var idx = 0; idx < len; idx++) {
    if (roles.indexOf(target) <= roles.indexOf(entities[idx].role)) {
      return true;
    }
  }

  return false;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/can.js
// module id = 98
// module chunks = 0